// Carry Roll Share report — shareable branded yardage report (11.6).

import type { FlightResult } from '@carry-roll/shared-types';

export function buildShareReport(result: FlightResult): string {
  return [
    'Carry Roll — Shot Distance Report',
    '==================================',
    '',
    `Carry:   ${Math.round(result.carryM)} m (${Math.round(result.carryM * 1.09361)} yd)`,
    `Roll:    ${Math.round(result.rollM)} m (${Math.round(result.rollM * 1.09361)} yd)`,
    `Total:   ${Math.round(result.totalM)} m (${Math.round(result.totalM * 1.09361)} yd)`,
    `Apex:    ${Math.round(result.apexM)} m`,
    `Shape:   ${result.shotShape}`,
    `Profile: ${result.profile}`,
    '',
    result.explanation,
  ].join('\n');
}

export function downloadTextReport(result: FlightResult): void {
  const text = buildShareReport(result);
  const blob = new Blob([text], { type: 'text/plain' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'carry-roll-report.txt';
  a.click();
  URL.revokeObjectURL(url);
}
